// L'API n'expose pas de route de constantes pour ces listes : les libellés
// reprennent mot pour mot ceux du Domain (TypeExport / StatutExport) — ce ne
// sont que des options de filtre et de formulaire, pas des données affichées
// venant de l'API.
export const TYPES_EXPORT = [
  // Le contenu de l'ancien bouton « Exporter en CSV (paginé) » des listes.
  { id: "LISTE_ALLOCATAIRE_FLUX", name: "Liste des allocataires (flux)" },
  { id: "LISTE_ALLOCATAIRE_STOCK", name: "Liste des allocataires (stock)" },
  {
    id: "LISTE_ALLOCATAIRE_TEMPORAIRE",
    name: "Liste des allocataires (temporaires)",
  },
  // Le contenu du fichier hebdomadaire transmis aux partenaires : les trois
  // familles réunies, avec la dernière orientation de chacun.
  {
    id: "TOUS_LES_ALLOCATAIRES",
    name: "Tous les allocataires (flux, stock et temporaires)",
  },
  // Le contenu de l'ancien bouton « Exporter en CSV (paginé) » de /cer-list.
  { id: "LISTE_CER", name: "Liste des CER" },
  // Le contenu de l'ancien bouton « Exporter en CSV (paginé) » de /users.
  { id: "LISTE_UTILISATEURS", name: "Liste des utilisateurs (back-office)" },
  // Les allocataires à qui Espoar ne peut pas écrire par SMS, pour que la Caf
  // corrige leurs numéros en amont (CE-1288).
  {
    id: "ALLOCATAIRES_SANS_MOBILE_VALIDE",
    name: "Allocataires sans mobile valide",
  },
];

export const STATUTS_EXPORT = [
  { id: "DEMANDE", name: "Demandé" },
  { id: "EN_COURS", name: "En cours de préparation" },
  { id: "TERMINE", name: "Prêt à télécharger" },
  { id: "ECHEC", name: "Échec" },
  { id: "EXPIRE", name: "Expiré" },
];
